import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import { Table, Select, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { downloadRequest, setCurrentModal } from "../../../store/actions/user";
import CreateUserModel from "../../../pages/User/CreateUser/CreateUserModal";
import { deleteUserEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "@vds/buttons";
import CustomModal from "../../../components/CustomModal";
import ToastNotification from "../ToastNotification";
import { fetchRolesListRequest, updatePaginationRequest } from "../../../store/actions/user";
import { DropdownFilterWithSearchAndCheckbox, DropdownFilterWithSearch } from "../../../components/DropdownFilter";

const { Option } = Select;

const UsersTable = ({
  userList,
  alertGroup,
  setSelectedUser,
  tableLoading,
  isEditable,
  permissions,
  userRoleName,
  onUserCreated,
  resetKey,
}) => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const currentModal = useSelector((state) => state.user.currentModal);
  const error = useSelector((state) => state.user.error);
  const loading = useSelector((state) => state?.user?.isLoading);
  const { roleId, name } = location.state || { roleId: "" };
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const rolesList = useSelector((state) => state.user.rolesList || []);
  const [sortedData, setSortedData] = useState([]);
  const filters = useSelector((state) => state.user.filters);
  const totalUserCount = useSelector((state) => state.user.totalUserCount);
  const [asc, setAsc] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUserr] = useState(null);
  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [message, setMessage] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [sortColumn, setSortColumn] = useState("userEmail"); // Default sort by email
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});

  const editUser = (record) => {
    if (record) {
      openModal(record);
    }
  };

  const deleteUser = (record) => {
    setSelectedUserr(record);
    setShowDeleteUser(true);
    dispatch(setCurrentModal(true))

  };
  const sortTableData = (data, key, isAsc = true) => {
  return [...data].sort((a, b) => {
    const aVal = (a[key] || '').toString().toLowerCase();
    const bVal = (b[key] || '').toString().toLowerCase();
    if (aVal < bVal) return isAsc ? -1 : 1;
    if (aVal > bVal) return isAsc ? 1 : -1;
    return 0;
  });
};

  const openModal = (user = null) => {
    setSelectedUserr(user);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedUserr(null);
  };
  const onExit = () => {
    setShowDeleteUser(false);
    dispatch(setCurrentModal(false))

  };
  const onConfirm = async () => {
    setShowDeleteUser(false);
    dispatch(setCurrentModal(false))
    const userIdToDelete = selectedUser?.id;
    const isIdInAnyGroup = alertGroup.some(groupItem => {
      if (groupItem && Array.isArray(groupItem.users) && groupItem.users.length > 0) {
        return groupItem.users.some(user => user && user.id === userIdToDelete);
      }
      return false;
    });
    if (isIdInAnyGroup) {
      setNotificationProps({
        type: "error",
        message: "Delete user",
        description: "User cannot be deleted due to active alert group.",
        duration: 1,
        style: { backgroundColor: "#FFECE0", color: "#8B4513" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
      return;
    }
    const response = await fetch(deleteUserEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        id: selectedUser?.id,
      }),
    });
    const deleteRuleRsp = await response;
    if (deleteRuleRsp) {
      if (deleteRuleRsp?.status === 200 || deleteRuleRsp?.status === 204) {
        setNotificationProps({
          type: "success",
          message: "Delete user",
          description: `User "${selectedUser?.email}" deleted successfully`,
          duration: 1,
          style: { backgroundColor: "#d4edda", color: "#155724" },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        onUserCreated();
      } else {
        setNotificationProps({
          type: "error",
          message: "Delete user",
          description: "failed",
          duration: 1,
          style: { backgroundColor: "#FFECE0", color: "#155724" },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
      }
    }
  };
  useEffect(() => {
    dispatch(fetchRolesListRequest());
  }, [user?.accountId]);


  let Organizations = [];
  let Roles = [];
  let Emails = [];
  let Names = [];
  userList?.forEach((val) => {
    const organization = organizationList?.find(
      (org) => org.id === val?.customdata?.orgId
    );
    const role = rolesList?.filter(
      (role) => role.id === val?.customdata?.roleId
    );
    if (organization && organization.tags?.[0]?.org_name) {
      const orgName = organization.tags[0].org_name;
      const orgId = organization.id;
      if (!Organizations.some((org) => org.text === orgName)) {
        Organizations.push({ text: orgName, value: orgId });
      }
    }
    if (role && role[0]?.name) {
      const roleName = role[0]?.name;
      const roleId = role[0]?.id;
      if (!Roles.some((rol) => rol.text === roleName)) {
        Roles.push({ text: roleName, value: roleId });
      }
    }
    if (!Emails.some((email) => email.text === val.email)) {
      Emails.push({ text: val.email });
    }
    if (
      !Names.some((name) => name.text === `${val?.firstname} ${val?.lastname}`)
    ) {
      const FullName = `${val?.firstname} ${val?.lastname}`;
      Names.push({ text: FullName, value: false, firstName: val?.firstname, lastName: val?.lastname });
    }
  });
  const handleOrganizationFilter = (val) => {
    if (!val) {
      setOrganizationFilter([]);
      setAsc(false);
      return;
    }
    setOrganizationFilter(val.filteredResult || []);
    setAsc(val.isAsc);
  };

  const handleNameFilter = (val) => {
    // const selectedNames = Names.filter(n => val.filteredResult.includes(n.text));
    // const firstNames = selectedNames.map(n => n.firstName);
    // const lastNames = selectedNames.map(n => n.lastName);
    setAsc(val.isAsc);
    setSortedData([]);
    dispatch(
      updatePaginationRequest({
        pageNo: 0,
        limit: filters.limit,
        searchName: val?.filters?.text,
        // searchFirstName: firstNames,
        // searchLastName: lastNames,
        sort: [
          {
            field: "firstname",
            order: val.isAsc ? "asc" : "desc",
          },
        ],
      })
    );
  };

  const handleRoleFilter = (val) => {
  const selectedRoles = Roles.filter(r => val.filteredResult.includes(r.text));
  const roleIds = selectedRoles.map(r => r.value);
  setAsc(val.isAsc);

  if (val.filteredResult.length === 0) {
    const sorted = sortTableData(dummyData, "role", val.isAsc);
    setSortedData(sorted);
  } else {
    setSortedData([]);
    dispatch(
    updatePaginationRequest({
      pageNo: 0,
      limit: filters.limit,
      roleFilter: roleIds,
    })
  );
  }

  
};

  const handleRoleResetFilter = (val) => {
    setSortedData([]);
    dispatch(
      updatePaginationRequest({
        pageNo: 0,
        limit: filters.limit,
        roleFilter: [],
      })
    );
  };

  const handleNameResetFilter = () => {
    setSortedData([]);
    dispatch(
      updatePaginationRequest({
        pageNo: 0,
        limit: filters.limit,
        searchName: [],
        searchFirstName: [],
        searchLastName: [],
      })
    );
  };

  const handleEmailFilter = (val) => {
    setSortedData([]);
    setAsc(val.isAsc);
    dispatch(
      updatePaginationRequest({
        pageNo: 0,
        limit: filters.limit,
        searchEmail: val?.filters?.text,
        sort: [
          {
            field: "email",
            order: val.isAsc ? "asc" : "desc",
          },
        ],
      })
    );
  };

  const handleEmailResetFilter = (val) => {
    setSortedData([]);
    dispatch(
      updatePaginationRequest({
        pageNo: 0,
        limit: filters.limit,
        searchEmail: [],
      })
    );
  };

  let dummyData = [];
  userList?.map((val) => {
    const organization = organizationList.filter(
      (org) => org.id === val?.customdata?.orgId
    );
    const role = rolesList?.filter(
      (role) => role.id === val?.customdata?.roleId
    );
    let isValidAction = true;

    // if (
    //   userRoleName?.toLowerCase()?.startsWith("super_admin") ||
    //   (Array.isArray(role) && role.length > 0 && role[0].name === userRoleName)
    // ) {
    //   isValidAction = true;
    // }

    dummyData.push({
      key: val?.uid,
      userEmail: val?.email,
      fullname: `${val?.firstname} ${val?.lastname}`,
      name: val?.firstname || "",
      lastname: val?.lastname || "",
      organization:
        organization.length > 0 ? organization[0].tags[0].org_name : "",
      role: role.length > 0 ? role[0].name : "",
      value: val,
      isValidAction,
      action: isValidAction ? (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item>
                <ul
                  className="dropdown-menu  show"
                  data-popper-placement="left-end"
                  style={{
                    position: "absolute",
                    inset: "auto 0px 0px auto",
                    margin: 0,
                    transform: "translate3d(-51px, -0.5px, 0px)",
                  }}
                >
                  <li>
                    <span
                      style={{ paddingLeft: 15, marginBottom: 5 }}
                      className="font-face-vzw dropdown-item"
                    >
                      Actions
                    </span>
                  </li>
                  <li>
                    {permissions?.users?.edit ? (
                      <li
                        className="dropdown-item"
                        onClick={() => editUser(val)}
                      >
                        <h6> Edit user</h6>
                      </li>
                    ) : (
                      <></>
                    )}
                  </li>
                  <li>
                    {permissions?.users?.edit ? (
                      <li
                        className="dropdown-item"
                        onClick={() => deleteUser(val)}
                      >
                        <h6> Delete user</h6>
                      </li>
                    ) : (
                      <></>
                    )}
                  </li>
                </ul>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            data-bs-toggle="dropdown"
            onClick={(e) => e.preventDefault()}
            data-testid="row-action"
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
      ) : null,
    });
  });

  const handleDownload = () => {
    try {
      dispatch(downloadRequest({
        accountName: sessionStorage.getItem("accountId"),
        currentrole: user?.role?.name || "ORG_ADMIN",
        ...filters
      }));
      if (error) {
        throw new Error(error);
      }
      setNotificationProps({
        type: "success",
        message: "Export",
        description: "Export completed successfully.",
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000); // Hide after 1 second
    } catch (error) {
      setNotificationProps({
        type: "error",
        message: "Export",
        description: error.message || "Unable to serialize unrecognized input.",
        duration: 5,
        style: { backgroundColor: "#FFECE0", color: "black" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 5000); // Hide after 5 seconds
    }
  };

  const columns = [
    {
      title: (
        <DropdownFilterWithSearch
          text="Name"
          isSortable={true}
          accountId={user?.accountId}
          resetKey={resetKey}
          onApply={handleNameFilter}
          onReset={handleNameResetFilter}
          // checkboxItems={Names?.map((name) => ({
          //   text: name?.text,
          //   value: filters.searchName?.includes(name.text),
          // }))}
        />
      ),
      dataIndex: "fullname",
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              minHeight: "5vh",
              alignItems: "center",
            }}
          >
            <div>
              <button
                className="custom-link"
                onClick={() => editUser(record.value)}
              >
                {`${record?.name} ${record?.lastname}`}
              </button>
            </div>
          </div>
        );
      },
      SortOrder: "ascend",
      width: "20%",
    },
    {
      title: (
        <div>
          <div className="d-flex table_column_header">
            <DropdownFilterWithSearch
              text="Email"
              isSortable={true}
              accountId={user?.accountId}
              resetKey={resetKey}
              onApply={handleEmailFilter}
              onReset={handleEmailResetFilter}
              // checkboxItems={Emails?.map((email) => ({
              //   text: email?.text,
              //   value: filters.searchEmail?.includes(email.text),
              // }))}
            />
          </div>
        </div>
      ),
      dataIndex: "userEmail",
      render: (text) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p className="mb-0">{text}</p>
            </div>
          </div>
        );
      },
      SortOrder: "descend",
      width: "25%",
    },
    false
      ? {
        title: permissions?.organizations?.view ? (
          <DropdownFilterWithSearchAndCheckbox
            text="Organization"
            isSortable={true}
            onApply={handleOrganizationFilter}
            onReset={handleOrganizationFilter}
            checkboxItems={Organizations?.map((organization) => ({
              text: organization?.text,
              value: organizationFilter?.includes(organization.text),
            }))}
          />
        ) : null,
        dataIndex: "organization",
        width: "20%",
        render: (text) => {
          return <div style={{ display: "flex" }}>{text}</div>;
        },
      }
      : {},
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Role"
          isSortable={true}
          onApply={handleRoleFilter}
          onReset={handleRoleResetFilter}
          checkboxItems={Roles?.map((rol) => ({
            text: rol?.text,
            value: filters.roleFilter?.includes(rol.value),
          }))}
        />
      ),
      dataIndex: "role",
      width: "20%",
      render: (text) => {
        return <div style={{ display: "flex" }}>{text}</div>;
      },
    },
    {
      title: permissions?.users?.download ? (
        <Dropdown
          placement="left"
          overlayClassName="ats-filter-overlay"
          overlay={
            <Menu style={{ width: "200px", padding: "10px" }}>
              <div
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                  paddingRight: "5px",
                }}
              >
                <div style={{ paddingLeft: 10, marginTop: 3 }}>
                  <span className="font-face-vzw">Action</span>
                  <div
                    style={{
                      marginTop: 6,
                      marginBottom: 3,
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                    onClick={handleDownload}
                  >
                    <span>Export</span>
                  </div>
                </div>
              </div>
              <Menu.Divider />
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            data-bs-toggle="dropdown"
            onClick={(e) => e.preventDefault()}
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
      ) : null,
      dataIndex: "action",
      width: "1%",
    },
  ];

  return (
    <Box
      sx={{
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopWidth: 0,
      }}
    >
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
      {isModalVisible && (
        <CreateUserModel
          visible={isModalVisible}
          rolesListData={rolesList}
          onClose={closeModal}
          onSave={closeModal}
          state={selectedUser}
          onUserCreated={() => {
            onUserCreated();
            setIsModalVisible(false);
          }}
        />
      )}
      <CustomModal popupName={''} customClass={'deleteAlertGroup'} popupTitle={'Delete user'} open={currentModal}>

        <>
          <p style={{ padding: '5px', marginTop: '25px', paddingLeft: '0px' }}>Are you sure you’d like to delete the user{" "} <span className="font-face-vzw">{selectedUser?.email} </span>?</p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%", backgroundColor: "white", color: "black", }}
                  onClick={() => onExit()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    onConfirm()
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      <Table
        data-testid="users-table"
        loading={tableLoading}
        style={{ marginTop: "24px" }}
        className="sasp_common-table"
        columns={columns}
        dataSource={sortedData.length > 0 ? sortedData : dummyData}
        pagination={{
          total: totalUserCount,
          current: filters.pageNo + 1,
          pageSize: filters.limit,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          pageSizeOptions: ["10", "20", "50", "100"],
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            dispatch(
              updatePaginationRequest({
                limit: pageSize,
                pageNo: page - 1,
              })
            );
          },
          locale: {
            items_per_page: "",
          },
        }}
      />
    </Box>
  );
};

export default UsersTable;